const AnalyticsTracking = {
    None: 1,
    GoogleUniversal: 2,
    FacebookPixel: 3,
    Custom: 4,
    GoogleAnalyticsClientId: 5,
    GoogleAnalyticsCrossDomainTracking: 6,
    GoogleAnalytics4: 7
};
export default AnalyticsTracking;
